
export default {
    namespaced: true,
}